import { render, staticRenderFns } from "./r-ad-placement-dialog.vue?vue&type=template&id=1a7232c8&scoped=true"
import script from "./r-ad-placement-dialog.vue?vue&type=script&lang=js"
export * from "./r-ad-placement-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-ad-placement-dialog.vue?vue&type=style&index=0&id=1a7232c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7232c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7232c8')) {
      api.createRecord('1a7232c8', component.options)
    } else {
      api.reload('1a7232c8', component.options)
    }
    module.hot.accept("./r-ad-placement-dialog.vue?vue&type=template&id=1a7232c8&scoped=true", function () {
      api.rerender('1a7232c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/ad-settings/placement/r-ad-placement-dialog.vue"
export default component.exports